import React, { FC } from 'react'

const Title: FC = ({ children }) => <div className="list-group__title">{children}</div>

const Items: FC<{ className?: string }> = ({ children, className = '' }) => (
  <div className={`list-group__items ${className}`}>{children}</div>
)

interface ItemProps {
  hover?: boolean
  isActive?: boolean
  className?: string
}

const Item: FC<ItemProps> = ({ children, className, hover = false, isActive = false }) => {
  const classes = [
    'list-group__item',
    className,
    hover && 'list-group__item--hover',
    isActive && 'list-group__item--active',
  ].filter((x) => !!x)
  return <div className={classes.join(' ')}>{children}</div>
}

export default {
  Title,
  Items,
  Item,
}
